import React from 'react'
import { SharedWithMe } from 'front-end/src/pages/home-page/components/shared-with-me/SharedWithMe'

export const SharedResourcesPage = () => (
  <div className="panel dashboard">
    <div className="panel-content no-banner">
      <SharedWithMe />
    </div>
  </div>
)
